
export default {
  "m":{
    "sms_login":"ショートメッセージログイン",
    "get_vercode":"発送",
    "change_mobile":"電話番号を変更する",
    "log_reg_agree":"ログイン/登録とは、{msg_ss}に同意することを意味します",
    "old_mobile":"元の電話番号",
    "new_mobile":"新しい電話番号",
    "agency_reginfo_fill":"ギルド登録情報を入力します",
    "audit_res":"監査結果",
    "agency_name":"ギルド名",
    "agency_name_input":"ギルド名を入力してください",
    "agency_name_input_note":"注：ギルド名は短くて覚えやすいものにすることをお勧めします。30語以内にしてください。",
    "agency_logo":"ギルドロゴ",
    "agency_logo_unpload_note":"クリアギルドロゴをPNG/JPG/JPEG形式でアップロードしてください",
    "agency_contact_name":"ギルド担当者",
    "user_contact_name":"ユーザープラットフォームと毎日連絡を取っている人の名前を入力してください",
    "agency_contact_phone":"ギルドの連絡先電話番号",
    "agency_whatsapp":"ギルドリーダーWhatsApp",
    "agency_whatsapp_contact":"ギルドリーダーのWhatsApp連絡先情報を入力してください",
    "agency_use_lang":"ギルドリーダーが使用する言語",
    "agency_head_ID":"ギルドリーダーID",
    "agency_ID_input":"後で資金を分配するために、ギルドリーダーのBuzzCastAPPのユーザーIDを入力してください",
    "reg_country":"登録国",
    "inhand_ID_photo":"手持ちの写真付き身分証明書",
    "upload_note_t":"アップロードに関する考慮事項",
    "agency_self_inhand_ID":"パスポートの書類を持ってエージェント自身が携帯する必要があります",
    "photo_must_clearly":"前面には、写真を撮って人物と実際のパスポート情報を明確に表示する必要があります",
    "mian_form_country":"ホストの主なソース国",
    "invite_code":"招待コード",
    "your_profile_submit_success":"書類は正常に送信されました。 私たちはできるだけ早くそれに対処します。<br>監査結果はギルド長のBuzzCast APP通知に送信されますので、ご確認ください！",
    "your_profile_approved":"提出したドキュメントがレビューに合格していません!拒否の理由は、パスポートを保持している写真が明確ではないからです。<br>再記入するか、BuzzCastAPPの公式アシスタントに連絡して相談してください。",
    "return_refill":"戻って補充する",
    "success_agency":"プラットフォームのインストールが成功しました。[クリックして]作業を開始してください。",
    "personal_account":"個人アカウント",
    "my_agency":"私のギルド",
    "your_agency_been_forcibly":"ギルドはプラットフォームによって強制的に終了され、システムにログインできなくなります。 ご不明な点がございましたら、BuzzCastAPPの公式アシスタントまたは専用オペレーションまでお問い合わせください。",
    "invite_live_join":"ギルドに参加するようにホストを招待します",
    "base_info":"基本情報",
    "apply_time":"出願日",
    "join_time":"参加時間",
    "cooper_status":"協力状況",
    "streamer_manage":"ホスト管理",
    "sereamer_apply":"ホストの承認",
    "sereamer_nickname":"ホストのニックネーム",
    "remark":"述べる",
    "no_remark":"備考なし",
    "add_remark":"コメントを追加",
    "birth":"生年月日",
    "user_status":"ユーザーステータス",
    "temporarily_frozen":"一時的な凍結",
    "permanently_frozen":"永久に凍結する",
    "fans_num":"フォロワー数",
    "sign_status":"契約状況",
    "sign_ing":"契約中",
    "sign_time":"契約日",
    "release_time":"キャンセル日",
    "live_viola_record":"生放送違反記録",
    "sign_record":"契約記録",
    "current_contract_status":"現在の契約状況",
    "termination_reason":"解約の理由",
    "violation_reason":"違反の理由",
    "violation_time":"違反日",
    "processing_result":"プロセス結果",
    "exported_data":"データのエクスポート",
    "join_agency_apply":"ギルドへの参加の承認",
    "audit_status":"承認状況",
    "pending_review":"保留中のレビュー",
    "pending_HQ_review":"本社のレビューを待っています",
    "not_approved_HQ":"本社のレビューに失敗しました",
    "withdrawn":"取り消されました",
    "audit_trail":"記録を確認する",
    "oper":"操作",
    "other_video_materials":"その他のビデオドキュメント",
    "pass":"合格",
    "pass_streamer_join_agency_apply":"アンカーメンバーシップアプリケーションを採用する",
    "reject_streamer_join_agency_apply":"アンカーメンバーシップの申請が拒否されました",
    "agree_streamer_join_agency":"アンカー{msg_ss1}に同意して、{msg_ss2}〜より下の送信者になります~",
    "reject_streamer_join_agency":"{msg_ss2}のメンバーになるためのメンバー{msg_ss1}の申請は拒否されます！",
    "img_material":"画像ドキュメント",
    "approver":"承認者",
    'user_enter_bind_phone':'電話番号を入力してください',
    'vericode':'検証コード',
    'input_vericode':'確認コードを入力してください',
    'login':'ログインする',
    'reg':'登録済み',
    'logout':'ログアウト',
    'search_for':'検索',
    'subscription_closed':'契約解除',
    'agency_ID':'ギルドコード：{msg_ss}',
    'reset':'リセットする',
    'live_ID':'ライブ放送室ID',
    'live_record':'生放送画面録画',
    'email':'メールアドレス',
    'phone':'電話',
    'mastery_lang':'身に付ける言語',
    'to':'To',
    'cancel':'キャンセル',
    'Confirm':'OK',
    'preview':'プレビュー',
    'rejected':'拒否されました',
    'tip':'プロンプト',
    'i_got_it':'わかった',
    'cancelled':'キャンセル',
    'refused':'拒否',
    'agency_agree':'ギルドは同意した',
    'platform_agree':'プラットフォームが合意しました',
    'user_not_exist':'このユーザーは存在しません',
    'user_frozen':'このユーザーはフリーズされています',
    'reviewing':'レビュー中',
    'review_pass':'監査の合格',
    'review_failed':'監査に失敗しました',
    'xx_hours':'{msg_ss} 時間',
    'xx_days':'{msg_ss} 日',
    'xx_hour': '{msg_ss} 時間',
    'xx_day': '{msg_ss} 日',
    'xx_year': '{msg_ss} 年',
    'xx_years': '{msg_ss} 年',
    'check_phone_istrue':'電話番号が正しく入力されているか確認してください',
    'male':'男性',
    'female':'女性',
    'avatar':'写真',
    'normal':'通常の',
    'live_room':'ライブルーム',
    'view':'見る',
    'oper_success':'成功した操作',
    'copy_success':'コピー成功',
    'new_mobile_already_reg':'新しい携帯番号が登録されました',
    'general_user':'一般ユーザー',

    'copy':'コピーする',
    'gender':'性別',
    'submit':'提出',
    'permanent':'永久',
    'agree_agreement':'契約に同意し、それを遵守する',
    'vericode_error':'確認コードが間違っています',
    'resend':'再発送します。',
    'approved':'合格した',
    'not_approved':'合格しなかった',
    'agency_rejected':'プラットフォームが拒否されました',
    'select':'選択',
    'search':'検索',
    'rejection_reason':'拒否の理由',
    'no_data':'データなし',
    'oper_failed':'操作に失敗しました',
    'leave_agency_apply':'ギルド撤退の承認',
    'over_word_limit':'制限文字数を超過する',
    'delete':'デリート',
    'nickname':'ニックネーム',
    'file_is_too_large':'大きすぎるファイル',

    'community_convention':'バズキャストコミュニティコンベンション',
    'approval_time':'決裁の時間',
    'guild_system_title':'BuzzCast ソーシャル プラットフォームのギルド システム',
    'return':'帰る',
    'img_upload_fail':'画像のアップロードに失敗しました',
    'cooper_ing':'合作中',
    'upload_file_format_incorrect':'アップロードされたファイルの形式が正しくありません',
    'token_invalid':'トークンが無効です。もう一度ログインしてください。',
    'network_busy':'ネットワークが混雑しています。もう一度お試しください',
    'minute':'{msg_ss}分',

    'live_room_ID':'ライブルーム ID',
    'scan_code':'BuzzCast アプリQRログイン',
    'open_code':'BuzzCastAppを開き、私のQRコードをクリックてスキャンする',
    'refresh':'再読み込み',
    'login_confirm':'ログイン確認',
    'account':'口座番号の情報',
    'user_name':'ユーザー名',
    'edit':'修正する',
    'changing':'バインでイングのアカウント',
    'mobile_number':'携帯電話アカウント',
    'mobile_login':'携帯電話番号{msg_ss}でのログインが可能です',
    'appId_login':'AppIDでスキャンして【{msg_ss}】のアカウントのログインができます。',
    'code_login':'BuzzCastAppIDがバインドされていないため、バインド後、QRコードでログインコードを読み取ることができます。',
    'verification_log':'携帯電話アカウントがバインドされていないため、バインド後、電話番号と検証コードでログイン。',
    'binding_success':'バインディング成功',
    'binding_mobile':'携帯電話番号のバインド',
    'edit_name':'ユーザー名を修正する',
    'binding_alert':'バインでイングのアカウントのヒント',
    'new_appId':'新しいAPPIDを使用して直接スキャンし、バインドすると、元のAPPIDは直接置き換えられます',
    'binding_account':'BuzzCastAppアカウントのバインド',
    'anchor_earings':'配信者の収益',
    'signing_date':'署名の日付',
    'statistical_date':'統計日',
    'valid_min':'合計有効時間（分）',
    'valid_day':'有効日数（日数）',
    'total_revenue':'総収入',

    'bind':'バインド',
    'please_agree_agree':'契約に同意してください',
    'note':'注: このシステムで表示される時間は、ニューヨーク時間 (EST) です。',
    'app_phone':'APPの携帯電話番号を登録する',
    'host_num':'ホスト数',
    'enter_host_num':'すべてのホストの番号を入力してください',
    'platform':'協力プラットフォーム',
    'statement':'毎月の銀行取引明細書',
    'enter_income':'平均月収を入力してください',
    'check_commas':'形式が正しくありません。 複数のプラットフォームがコンマで区切られているかどうかを確認してください',
    'submit_success':'書類は正常に送信されました。 私たちはできるだけ早くそれに対処します',
    'usd':'米ドル',
    'many_platforms':'これまでにご協力いただいたライブ配信プラットフォームを最大20プラットフォームまで入力してください',
    'limit_platform': '最大 20 のプラットフォーム',
    'user_has_delete':'ユーザーはログアウトされました',
    'cant_commit':'すでに契約放送局であり、同時にギルドへの入居申請を行うことはできません',
    'cant_commit_1':'すでに契約放送局を申請しており、同時にギルドへの入居申請を行うことはできません',
    'passwd': 'パスワード',
    'passwd_placeholder': '暗証番号は６桁から20桁まで支持する事が出来ます',
    'live_rights': '時間のない評価',
    'edit_log': '変更記録',
    'edit_time': '時間を変えます',
    'edit_pwd': 'パスワードを変更する',
    'old_pwd': '以前のパスワード',
    'new_pwd': '新しいパスワード',
    'confirm_pwd': 'パスワードを認証する',
    'forget_pwd': '暗証番号が忘れましたか？',
    'email_check': '電子メール形式が正しくありません。',
    'phone_pwd_error': '携帯番号或いは暗証番号が違います',
    'ten_min_error': '10分間試してみてください',
    'phone_bind_error': '携帯電話番号は他のアカウントにバインドされています。バインドする新しい携帯電話番号を置き換えてください。',
    'bc_user_id_tip': 'Buzzcast APP ID',
    'bc_user_id_error': 'ギルドリーダー ID はすでに入力されています。もう一度入力してください',
    'pwd_error': '間違ったパスワード',
    'phone_not_reg_error': 'アカウントは登録されていません',
    'pwd_nq': '入力された新しいパスワードは矛盾しています',
    'sign_anchor_error': 'すでに契約放送局であり、同時にギルドへの入居申請を行うことはできません',
    'apply_anchor_error': 'すでに契約放送局を申請しており、同時にギルドへの入居申請を行うことはできません',
    'have-expired':'有効期限が切れた',
    'approval-time':'承認時間',
    'reasons-for-refusal':'拒否の理由を入力してください',
    'Transfer-grounds':'ギルドを変更した理由',
    'code_expire': '認証コードの有効期限が切れたので、認証コードをクリックして更新してください',
    'transfer-approval':' 譲渡承認',
    'live_state_placeholder': 'スタートステータス',
    'live_state_open': '通常',
    'live_state_temporary_banned': '放送禁止',
    'live_state_forever_banned': '永久放送禁止',
    'live_allowed_time': '開始時間を許可する',
    'live_banned_time': '放送禁止期間',
    'deduct_money': 'Bコインの金額を差し引く',
    'final_income': '実際の収益',
    'select_start_dt': '選択し開始時間',
    'select_end_dt': '選択し終了時間',
    'less_then_end_dt': '開始時間は小なりイコール終了時間',
    'System_automatically_through':'システムは自動的に通過します',
    'btrade_err': 'このギルドIDは使用できません',

    'mouth_anchor': '月給制ライバー',
    'day_anchor': '日給制ライバー',
    'guild_anchor': 'ギルド長報酬(日給)',
    'mouth_anchor_st': '月給開始時間',
    'mouth_anchor_et': '月給終了時間',
    'day_anchor_st': '日給開始時間',
    'day_anchor_et': '日給終了時間',
    'all_award_bcoin': '日給報酬総収益',
    'live_hour': 'ライブ配信時間達成報酬',
    'salary_day': '日付',
    'day_in_come': 'ギルドの当日収益(Bコイン)',
    'award_ration_flag_str': '報酬の比率',
    'payable_money': 'ギルド長のBコイン報酬',
    'host_bcoins': 'ライバーの収益Bコイン',
    'total_official': '公式からの報酬Bコイン総数',
    'actual_bcoins_awarded': '実際の報酬Bコイン',
    "change_bound_account":"紐付けのアカウントを変更" ,
    "agent_id_form":"ギルド長のID:" ,
    "BuzzCast_verification_code":"BuzzCast認証コード:" ,
    "send_success":"送信成功" ,
    "account_changed_successfully":"紐付けのアカウントを変更できました。" ,
    "invite_guild_url":"BuzzCastのギルド長として招待するURL:{msg_ss}" ,
    "invite_guild_code":"私の招待コード:{msg_ss}" ,
    "save":"保存" ,
    "compile":"編集" ,
    "agent_nvitation_eward":"ギルド長招待報酬" ,
    "agent_name":"ギルド長のニックネーム" ,
    "guild_id":"ギルドコード" ,
    "guild_income_30days":"直近30日間のギルド収益" ,
    "guild_invite_income_30days":"直近30日間のギルド招待収益" ,
    "agency_commission_ratio":"代理手数料" ,
    "invite_income_bcoins":"招待報酬Bコイン" ,
    "id_not_exist": "IDは存在しません",
    'reward_distribution_status': '報酬配布状況',
    'must_number': '入力は純粋な数値形式である必要があります。',

  },
}



// WEBPACK FOOTER //
// ./src/i18n/lang/ja.js